var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"humans-table"},_vm._l((_vm.list),function(employee){return _c('people-list-item',{key:employee.id,attrs:{"active":employee.id===_vm.activeId,"employee":employee,"show-quetionnaire":_vm.showQuetionnaire}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }